<div *ngIf="!isMatrix">
  <div class="row p-2" style="display: flex; justify-content: space-between">
    <div *ngIf="showName" class="mat-body-1 displayFlex" [ngClass]="{'col-md-7':!IsConsentScreen,'col-md-10':IsConsentScreen}">
      <span *ngIf="!IsConsentScreen" [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span *ngIf="IsConsentScreen" [innerHTML]="question.consentQuestionLabel || question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
  </div>
    <div class="mat-body-1" [ngClass]="{'col-md-4': showName && !IsConsentScreen,'col-md':IsConsentScreen}">
      <!-- <div  *ngFor="let opt of question.options; let k = index">         
        <mat-radio-button [value]="opt.value" [disabled]="IsReadOnly" [(ngModel)]="question.responseText" (change)="onSelect($event,question ,k)">
          {{opt.value}}</mat-radio-button>
      </div> -->
      <mat-radio-group [value]="question.responseText" class="example-radio-group">
        <mat-radio-button 
          *ngFor="let option of question.options; let i = index"
          [value]="option.value"
          [checked]="option.value === question.responseText"
          [ngClass]="{'disable-rdo': IsReadOnly}"
          [disabled]="IsReadOnly"
          (click)="onRadioClick($event, option.value, i)">
          {{option.value}}
        </mat-radio-button>
        <br />
      </mat-radio-group>
    </div>
  </div>
</div>

<div *ngIf="errormgvisible" class="offset-8">
  <div class="mat-body-1 errormsg margin-top" *ngFor="let error of validationerrormessage">
    {{ error }}
  </div>
</div>
